import React from "react";
import {connect} from "react-redux";
import axios from "axios";
import {userService} from "../../../services/UserService";
import 'leaflet/dist/leaflet.css';
import actionTypes from "../../../store/actionTypes";
import {IStore} from "../../../store/reducers";
import Mapa from "./Mapa";
import Draggable from 'react-draggable';
import {ArrowLeft, ArrowRight} from "@material-ui/icons";
import {IParcela} from "../../../types";
import MenuVisualizador from "./MenuVisualizador";
import {Typography} from "@material-ui/core";
import {resolucion_tablet} from "../../../tools/resolucion";

const config = require('../../../config.json');


interface IProps {
    product: string
    parcela: IParcela
    scale: Record<number, (number | string)[]>
    setScale(scale: Record<number, (number | string)[]>): void
}

interface Istate {
    show: boolean
    vertical: boolean
    cambiando: boolean
}


class Escala extends React.Component<IProps, Istate> {

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<Istate>, nextContext: any): boolean {
        if (this.props.product !== nextProps.product) {
            if (nextProps.product.length !== 0 && nextProps.product.split(',')[2] !== 'rgb') {
                let fuente = ""
                const parcela = this.props.parcela.id
                const fecha = (nextProps.product.split(',')[1]).split('/').reverse().join('-')
                let indice = ""

                if (["Humedad"].includes(nextProps.product.split(',')[2])) {
                    fuente = 'Humedad'
                    indice = 'humedad'
                }
                if (["ETc_hibrida", "ETc_high", "ETc_low"].includes(nextProps.product.split(',')[2])) {
                    fuente = nextProps.product.split(',')[2]
                    indice = 'ETc_24'
                }
                if (["dsm"].includes(nextProps.product.split(',')[2])) {
                    fuente = "DSM"
                    indice = 'dsm'
                }
                if (["clay"].includes(nextProps.product.split(',')[2])) {
                    fuente = "Clay"
                    indice = 'clay'
                }
                if (nextProps.product.split(',')[0]==="satelite" && nextProps.product.split(',')[2] === "lst") {
                    fuente = 'landsat_8'
                    indice = nextProps.product.split(',')[2]
                }
                if (nextProps.product.split(',')[0]==="satelite" && nextProps.product.split(',')[2] !== "lst") {
                    fuente = 'sentinel_2a'
                    indice = nextProps.product.split(',')[2]
                }
                if (nextProps.product.split(',')[0]==="dron") {
                    fuente = 'rpas'
                    indice = nextProps.product.split(',')[2]
                }

                let url = config.url+`/static/visualizador/${fuente}/${parcela}/${fecha}/legend_${indice}.json`
                if (["dsm", "clay"].includes(nextProps.product.split(',')[2])) {
                    url = config.url+`/static/visualizador/${fuente}/${parcela}/legend_${indice}.json`
                }

                axios.get(
                    url,
                    {auth: {
                            username: `${userService.getUser()}`,
                            password: `${userService.getPass()}`
                        }}
                )
                    .then((res) => {
                        this.props.setScale(res.data)
                        this.setState({show: true})
                    })
                    .catch(() => {})
            } else {
                this.setState({show: false})
                this.props.setScale({})
            }

        }
        return true
    }

    state:Istate = {
        show: false,
        vertical: window.matchMedia("(orientation: portrait)").matches,
        cambiando: false,
    }

    render() {
        const doOnOrientationChange = () => {
            if (!this.state.cambiando) {
                this.setState({cambiando: true, vertical: !this.state.vertical})
                setTimeout(() => this.setState({cambiando: false}), 100)
            }
        }

        window.addEventListener("orientationchange", function() {
            doOnOrientationChange()
        }, false)

        if (this.state.show) {
            if (this.props.product.split(",")[this.props.product.split(",").length-1] === "clay") {
                return (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: 150,
                            height: this.state.vertical || resolucion_tablet() ? `${20*2/5}%` : `${40*2/5}%`,
                            marginLeft: -160,
                            marginTop: 30,
                            backgroundColor: "rgba(255,255,255,0.8)",
                            zIndex: 100,
                            alignItems: "center",
                            borderRadius: 12,
                            borderStyle: "solid",
                            borderWidth: 2,
                            borderColor: "rgba(255,255,255,0.6)"
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: 'row',
                                width: '100%',
                                height: `${100 / 2}%`,
                                alignItems: "center",
                                justifyContent: "space-between"
                            }}
                        >
                            <div
                                style={{
                                    height: 20,
                                    width: 20,
                                    backgroundColor: this.props.scale[4][0] as string,
                                    borderRadius: 20,
                                    marginLeft: 5
                                }}
                            />
                            <Typography
                                style={{
                                    fontWeight: "bold",
                                    marginLeft: 10,
                                    marginRight: 5
                                }}
                            >
                                Más Arcilloso
                            </Typography>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: 'row',
                                width: '100%',
                                height: `${100 / 2}%`,
                                alignItems: "center",
                                justifyContent: "space-between"
                            }}
                        >
                            <div
                                style={{
                                    height: 20,
                                    width: 20,
                                    backgroundColor: this.props.scale[0][0] as string,
                                    borderRadius: 20,
                                    marginLeft: 5
                                }}
                            />
                            <Typography
                                style={{
                                    fontWeight: "bold",
                                    marginLeft: 10,
                                    marginRight: 5
                                }}
                            >
                                Más Arenoso
                            </Typography>
                        </div>
                    </div>
                )
            } else {
                return (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: 80,
                            height: this.state.vertical || resolucion_tablet() ? '20%' : '40%',
                            marginLeft: -110,
                            marginTop: 30,
                            backgroundColor: "rgba(255,255,255,0.8)",
                            zIndex: 100,
                            alignItems: "center",
                            borderRadius: 12,
                            borderStyle: "solid",
                            borderWidth: 2,
                            borderColor: "rgba(255,255,255,0.6)"
                        }}
                    >

                        {Object.keys(this.props.scale).reverse().map((i) =>
                            <div
                                key={i}
                                style={{
                                    display: "flex",
                                    flexDirection: 'row',
                                    width: '100%',
                                    height: `${100 / Object.keys(this.props.scale).length}%`,
                                    alignItems: "center",
                                    justifyContent: "space-between"
                                }}
                            >
                                <div
                                    key={i}
                                    style={{
                                        height: 20,
                                        width: 20,
                                        backgroundColor: this.props.scale[parseInt(i)][0] as string,
                                        borderRadius: 20,
                                        marginLeft: 5
                                    }}
                                />
                                <Typography
                                    style={{
                                        fontWeight: "bold",
                                        marginLeft: 10,
                                        marginRight: 5
                                    }}
                                >
                                    {this.props.product.split(',')[2] === 'lst' ?
                                        Math.round((this.props.scale[parseInt(i)][1] as number - 273.15) * 10) / 10
                                        :
                                        this.props.product.split(',')[2] === 'dsm' ?
                                            Math.round(this.props.scale[parseInt(i)][1] as number * 10) / 10
                                            :
                                            Math.round(this.props.scale[parseInt(i)][1] as number * 100) / 100
                                    }
                                </Typography>
                            </div>
                        )}
                    </div>
                )
            }
        } else {
            return null
        }
    }
}

const mapStateToProps = (state: IStore) => ({
    product: state.visualizador.product,
    parcela: state.visualizador.parcela,
    scale: state.visualizador.scale,
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setScale: (scale: Record<number, (number | string)[]>) => dispatch({type: "set-visualizador-scale", scale})
});

export default connect(mapStateToProps, mapDispatchToProps)(Escala);
